import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2078833a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-info nongfu-button-wrap xag-page__footer" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "expand-table-content" }
const _hoisted_4 = { class: "insurance-factor-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保险系数", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 平安保险根据您在“意外机损保险”服务期限内的设备维修情况调整（上下浮动）次年增值服务/保险产品或一年内二次购买价格。 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "次年增值服务/保险产品系数参考如下：", -1))
const _hoisted_9 = { class: "table-wrap" }
const _hoisted_10 = {
  class: "table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "head-tr" }, [
  /*#__PURE__*/_createElementVNode("th", null, "出险次数"),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("div", null, "保费系数"),
    /*#__PURE__*/_createElementVNode("div", null, "（基础保费下系数）")
  ])
], -1))
const _hoisted_12 = { class: "button-wrap" }

import { v4 as uuidv4 } from 'uuid'
import { useRouter } from 'vue-router'
import { Popup, Loading, Button } from 'vant'
import { getActivedDayValue } from '../common'
import { getDeviceInsuranceInfo } from '@/apis/insurance'
import { useCustomServiceInfo } from '@/compositions/insurance/index'
import { withDefaults, ref, Ref, ComputedRef, computed } from 'vue'
import PopupHeader from '@/components/popup/popup-header.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import { DeviceJijiaInsuranceInfoProjectItem } from '@/types/insurance'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-factor-view-popup',
  props: {
    show: { type: Boolean, default: false },
    data: null
  },
  emits: ['update:show', 'can-next'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, data: DeviceJijiaInsuranceInfoProjectItem | null };

const { callHandle, phone } = useCustomServiceInfo()


const $router = useRouter()


const insuranceFactor = computed(() => {
  return props.data?.interest_rate
})

const tableList = [
  { label: '0', value: '0.8' },
  { label: '1', value: '0.9' },
  { label: '0（但退保）', value: '1' },
  { label: '2', value: '1' },
  { label: '3', value: '1.1' },
  { label: '4', value: '1.3' },
  { label: '5-6', value: '1.5' },
  { label: '7及以上', value: '2' },
]

const activeIndex = computed(() => {
  let num = props.data?.danger_num || 0
  let rate = props.data?.interest_rate || 1
  if (num === 0) {
    return rate === 0.8 ? 0 : 2
  }
  if (num >= 7) {
    return 7
  }
  if (num === 5 || num === 6) {
    return 6
  }
  if (num === 1) {
    return 1
  }
  return num + 1
})

function hidePopup() {
  emits('update:show', false)
}
function confirmNext() {
  emits('can-next', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: props.show,
    position: "bottom",
    class: "custom-popup-border-radius",
    onClickOverlay: hidePopup,
    onClickCloseIcon: hidePopup
  }, {
    default: _withCtx(() => [
      _createVNode(PopupHeader, {
        onClose: hidePopup,
        title: "保险系数说明"
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(insuranceFactor)), 1)
            ]),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _hoisted_11,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableList, (item, index) => {
                  return _createElementVNode("tr", {
                    key: index,
                    class: _normalizeClass(index === _unref(activeIndex) ? 'active-tr' : '')
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.label), 1),
                    _createElementVNode("td", null, _toDisplayString(item.value), 1)
                  ], 2)
                }), 64))
              ])
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" 以上系数信息不适用于一年内二次购买价格浮动系数。如您对价格有疑问，请致电 "),
              _createElementVNode("span", {
                class: "phone-number",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(callHandle) && _unref(callHandle)(...args)))
              }, _toDisplayString(_unref(phone)), 1)
            ])
          ])
        ]),
        _createVNode(CommonFooterWrap, { class: "van-hairline--top" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(Button), {
                class: "next-button xa-vant-button",
                round: "",
                onClick: confirmNext
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认并投保")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})